import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "firesafety-EmergencyLighting-HQ",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "Emergency Lighting-HQ",
    description: "EmergencyLighting-HQ",
    image: require("./EmergencyLighting-HQ.svg"),
    svgIcon: require("./EmergencyLighting-HQ.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 120,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 120,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g>
          <defs>
            <style>{`.elhqcls-1{fill:#019e4d;}.elhqcls-2{fill:#fff;}`}</style>
          </defs>
          <g
            transform={`translate(-47, 55) scale(1, -1)`}
            id={`${element.type}-${element.id}`}
            data-name="corner shower"
          >
            <path
              class="elhqcls-1"
              d="M.06,100.1V.06h100v100ZM67.21,64.38a.76.76,0,0,0,.06-.44c0-2.22,0-4.44,0-6.66q0-10.11,0-20.22c0-.13,0-.26,0-.38a1.06,1.06,0,0,0-.05-.23l-.33,0H62.16l-.34,0a3.23,3.23,0,0,0-.18.28q-3.89,6.57-7.78,13.12l-2.14,3.61c0,.07-.07.17-.18.21l-.14-.22L42.18,38.18l-.94-1.56a.34.34,0,0,0-.31-.19H36l-.21,0a1.71,1.71,0,0,0,0,.55q0,13.39,0,26.79c0,.11,0,.23,0,.35a1.18,1.18,0,0,0,0,.2c.28,0,4.9.08,5.87,0l.18,0a.9.9,0,0,0,0-.45V48.35s0-.09.06-.11l.16.26q3.84,6.28,7.66,12.59l.14.22a.25.25,0,0,0,.26.15h2.36c.47,0,.39.06.63-.35L59,51.28,61,48c0-.06,0-.15.15-.14v.32q0,7.8,0,15.59c0,.12,0,.25,0,.38s0,.14,0,.22l.14,0h5.79ZM9,64.38l.16,0H30.53a.32.32,0,0,0,.09,0,.71.71,0,0,0,.05-.38V59.64a2.09,2.09,0,0,0,0-.25.58.58,0,0,0,0-.18,1,1,0,0,0-.42,0H15.67a.58.58,0,0,1-.14,0,.67.67,0,0,1-.06-.39V53.18a1.62,1.62,0,0,1,0-.22.8.8,0,0,1,0-.15.77.77,0,0,1,.42,0h12c.11,0,.21,0,.32,0a.88.88,0,0,0,.2,0c0-.13,0-.24,0-.36V47.88c0-.16-.05-.2-.22-.21H15.7l-.17,0a.82.82,0,0,1-.06-.43V42.15a2.62,2.62,0,0,1,0-.28,1.24,1.24,0,0,1,0-.16,1.52,1.52,0,0,1,.42,0h14a.65.65,0,0,0,.16,0,.51.51,0,0,0,.06-.33c0-2.48,0-4.58,0-4.83a1,1,0,0,0-.5-.06H9.23l-.22,0A1.81,1.81,0,0,0,9,37V63.84c0,.12,0,.24,0,.35A.58.58,0,0,0,9,64.38ZM80.34,59V36.67a1.13,1.13,0,0,0,0-.18,1,1,0,0,0-.48-.06H74a1,1,0,0,0-.22.05c0,.17,0,.33,0,.49V63.86c0,.11,0,.21,0,.32a.65.65,0,0,0,0,.2c.36.05,18.22.07,20.2,0l.22,0s0-.07,0-.1c0-1.62,0-3.24,0-4.86,0-.09,0-.19,0-.3a1,1,0,0,0-.22-.05H80.57A1.24,1.24,0,0,1,80.34,59Z"
              transform="translate(-0.06 -0.06)"
            />
            <path
              class="elhqcls-2"
              d="M67.21,64.38l-.12,0H61.3l-.14,0c0-.08,0-.15,0-.22s0-.26,0-.38q0-7.8,0-15.59v-.32C61,47.86,61,48,61,48l-2,3.27-5.86,9.83c-.24.41-.16.35-.63.35H50.15a.25.25,0,0,1-.26-.15l-.14-.22q-3.82-6.3-7.66-12.59l-.16-.26c-.08,0-.06.07-.06.11V63.93a.9.9,0,0,1,0,.45l-.18,0c-1,0-5.59,0-5.87,0a1.18,1.18,0,0,1,0-.2c0-.12,0-.24,0-.35q0-13.4,0-26.79a1.71,1.71,0,0,1,0-.55l.21,0h5a.34.34,0,0,1,.31.19l.94,1.56L51.4,53.46l.14.22c.11,0,.13-.14.18-.21l2.14-3.61q3.89-6.55,7.78-13.12a3.23,3.23,0,0,1,.18-.28l.34,0H66.8l.33,0a1.06,1.06,0,0,1,.05.23c0,.12,0,.25,0,.38q0,10.11,0,20.22c0,2.22,0,4.44,0,6.66A.76.76,0,0,1,67.21,64.38Z"
              transform="translate(-0.06 -0.06)"
            />
            <path
              class="elhqcls-2"
              d="M9,64.38a.58.58,0,0,1,0-.19c0-.11,0-.23,0-.35V37a1.81,1.81,0,0,1,0-.56l.22,0H29.61a1,1,0,0,1,.5.06c.05.25.07,2.35,0,4.83a.51.51,0,0,1-.06.33.65.65,0,0,1-.16,0h-14a1.52,1.52,0,0,0-.42,0,1.24,1.24,0,0,0,0,.16,2.62,2.62,0,0,0,0,.28v5.06a.82.82,0,0,0,.06.43l.17,0H28.21c.17,0,.21,0,.22.21v4.48c0,.12,0,.23,0,.36a.88.88,0,0,1-.2,0c-.11,0-.21,0-.32,0h-12a.77.77,0,0,0-.42,0,.8.8,0,0,0,0,.15,1.62,1.62,0,0,0,0,.22v5.57a.67.67,0,0,0,.06.39.58.58,0,0,0,.14,0H30.2a1,1,0,0,1,.42,0,.58.58,0,0,1,0,.18,2.09,2.09,0,0,1,0,.25V64a.71.71,0,0,1-.05.38.32.32,0,0,1-.09,0H9.18Z"
              transform="translate(-0.06 -0.06)"
            />
            <path
              class="elhqcls-2"
              d="M80.34,59a1.24,1.24,0,0,0,.23,0H94.1a1,1,0,0,1,.22.05c0,.11,0,.21,0,.3,0,1.62,0,3.24,0,4.86,0,0,0,.06,0,.1l-.22,0c-2,0-19.84,0-20.2,0a.65.65,0,0,1,0-.2c0-.11,0-.21,0-.32V37c0-.16,0-.32,0-.49a1,1,0,0,1,.22-.05h5.79a1,1,0,0,1,.48.06,1.13,1.13,0,0,1,0,.18V59Z"
              transform="translate(-0.06 -0.06)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
